import _ from 'underscore'

// Set Underscore globally
window._ = _
